export default "__VITE_ASSET__CCJdEsuN__"